import api from "@/lib/api";

export const publishCms = (body) => api.post("/cc/cms/publish", body).then((r) => r.data);
export const cmsVersions = (target, docId) => api.get("/cc/cms/versions", { params: { target, doc_id: docId } }).then((r) => r.data.versions);
export const restoreCms = (body) => api.post("/cc/cms/restore", body).then((r) => r.data);

export const SITE_BASE = "https://brugo.in";
export const resolveImg = (src) => (!src ? "" : /^(https?:|data:|blob:)/.test(src) ? src : `${SITE_BASE}${src.startsWith("/") ? "" : "/"}${src}`);
